/**
 * PublicPageNav — legacy wrapper kept so existing pages don't change imports.
 * Renders the unified AppNav with the user's site-wide theme preference.
 */
import React from "react";
import AppNav from "./AppNav";
import { useDarkMode } from "../hooks/useDarkMode";

const ACTIVE_MAP = {
  brief: "content",
  archive: "content",
  podcast: "content",
  newsletter: "content",
  ask: "ask",
  reports: "reports",
  insights: "insights",
};

export default function PublicPageNav({ active = "" }) {
  const [dm] = useDarkMode();
  return <AppNav active={ACTIVE_MAP[active] || ""} darkMode={dm} />;
}
